(() => {
  const init = (root) => {
    if (!root || root.dataset.collectionsAzReady === 'true') return;
    root.dataset.collectionsAzReady = 'true';

    const nav = root.querySelector('[data-collections-az-nav]');
    const links = [...root.querySelectorAll('[data-collections-az-link]')];
    const groups = [...root.querySelectorAll('[data-collections-az-group]')];
    if (!nav || !links.length || !groups.length) return;

    const updateHeaderOffset = () => {
      const header = document.querySelector('.t4s-header__wrapper, .t4s-section-header');
      const height = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      root.style.setProperty('--collections-az-header-offset', `${height}px`);
      return height;
    };

    const setActive = (letter) => {
      links.forEach((link) => {
        const active = link.dataset.collectionsAzLink === letter;
        link.classList.toggle('is-active', active);
        if (active) {
          link.setAttribute('aria-current', 'true');
          const left = link.offsetLeft - (nav.clientWidth - link.offsetWidth) / 2;
          nav.scrollTo({ left, behavior: 'smooth' });
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        const offset = updateHeaderOffset() + nav.offsetHeight + 16;
        const top = window.scrollY + target.getBoundingClientRect().top - offset;
        window.scrollTo({ top, behavior: 'smooth' });
        history.replaceState(null, '', link.getAttribute('href'));
        setActive(link.dataset.collectionsAzLink);
      });
    });

    let ticking = false;
    const updateActive = () => {
      ticking = false;
      const marker = nav.getBoundingClientRect().bottom + 24;
      let active = groups[0];
      groups.forEach((group) => {
        if (group.getBoundingClientRect().top <= marker) active = group;
      });
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
        active = groups[groups.length - 1];
      }
      setActive(active.dataset.collectionsAzGroup);
    };

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateActive);
    }, { passive: true });

    window.addEventListener('resize', updateHeaderOffset, { passive: true });

    updateHeaderOffset();
    updateActive();
  };

  document.querySelectorAll('[data-collections-az]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('[data-collections-az]'));
  });
})();
